import * as OrderTexts from '../../../../../../../intl'
import { form } from '../../../../formState'

import { OrderFormValues } from '../../../../typings'
import { Props } from '../../typings'

import { BarcodeField } from './components/BarcodeField'

import { BarcodesValidationResult, validateBarcodes } from './validation/validateBarcodes'

export function Barcodes(props: Props) {
  const { orderStepType, orderStep, maxBarcodes } = props

  const podsBarcodes = orderStep.trackingData?.pods?.barcodes || []

  const fieldName = `${orderStepType}.barcodes` as 'pickup.barcodes' | 'delivery.barcodes'

  form.useAddFieldValidation<typeof fieldName>(fieldName, (field, _formApi) => {
    const barcodes = field.value

    if (barcodes.length > 0) {
      const barcodeValidation: BarcodesValidationResult = validateBarcodes(barcodes)
      const hasErrors = barcodeValidation.some(e => e !== null)

      if (hasErrors) {
        return JSON.stringify(barcodeValidation)
      }

      if (barcodes.length > maxBarcodes) {
        return OrderTexts.getBarcodesValidationText('maxCountViolation', maxBarcodes, maxBarcodes)
      }
    }
  })

  return (
    <BarcodeField<`${typeof orderStepType}.barcodes`, OrderFormValues>
      barcodeProps={{ label: OrderTexts.getBarcodesFieldText(), maxBarcodes, podsBarcodes }}
      name={`${orderStepType}.barcodes`}
      testId="barcodes"
    />
  )
}
